import { z } from 'zod';
import { FULFILLMENT_STATUSES, ORDER_STATUSES } from '../types/enums.js';
import { dateSchema, moneySchema, paginationQuerySchema, sortOrderSchema, uuidSchema, } from './common.js';
export const orderListQuerySchema = paginationQuerySchema.extend({
    search: z.string().trim().max(200).optional(),
    status: z.enum(ORDER_STATUSES).optional(),
    fulfillmentStatus: z.enum(FULFILLMENT_STATUSES).optional(),
    customerId: uuidSchema.optional(),
    from: dateSchema.optional(),
    to: dateSchema.optional(),
    sortBy: z.enum(['createdAt', 'grandTotal', 'orderNumber']).default('createdAt'),
    sortOrder: sortOrderSchema,
});
export const updateOrderStatusSchema = z.object({
    status: z.enum(ORDER_STATUSES),
    note: z.string().trim().max(1000).optional(),
});
export const updateOrderSchema = z.object({
    notes: z.string().trim().max(2000).nullable().optional(),
    fulfillmentStatus: z.enum(FULFILLMENT_STATUSES).optional(),
    trackingNumber: z.string().trim().max(120).nullable().optional(),
    courierName: z.string().trim().max(120).nullable().optional(),
});
export const refundOrderSchema = z.object({
    /** Omitted means refund the full captured amount. */
    amount: moneySchema.optional(),
    reason: z.string().trim().min(1, 'Enter a reason for the refund').max(500),
});
export const createShipmentSchema = z.object({
    courierName: z.string().trim().min(1).max(120),
    trackingNumber: z.string().trim().min(1).max(120),
    trackingUrl: z.string().url().max(2048).nullable().optional(),
    note: z.string().trim().max(500).optional(),
});
//# sourceMappingURL=order.js.map